import { Component, ViewEncapsulation } from '@angular/core';

@Component ({
    selector : 'zsd-plannedoutagesdetailcontainer',
    templateUrl : '../view/planned-outagesdetailcontainer.component.html',
    styleUrls : ['../view/planned-outagesdetailcontainer.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class PlannedOutagesDetailContainerComponent {
}
